import api from './api';

export const maintenancePhotosService = {
  /**
   * Subir fotos de mantenimiento
   * @param {number} maintenanceId - ID del mantenimiento
   * @param {FileList|File[]} files - Archivos de fotos
   * @param {string} createdBy - Usuario que sube las fotos
   * @returns {Promise<Object>}
   */
  async uploadPhotos(maintenanceId, files, createdBy = null) {
    try {
      const formData = new FormData();
      formData.append('maintenance_id', maintenanceId);
      if (createdBy) {
        formData.append('created_by', createdBy);
      }
      
      // Agregar cada archivo al FormData
      for (let i = 0; i < files.length; i++) {
        formData.append('photos', files[i]);
      }
      
      const response = await api.post(
        '/maintenance-photos/upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 300000 // 5 minutos para subir fotos grandes
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Error uploading photos:', error);
      throw error;
    }
  },

  /**
   * Obtener fotos de un mantenimiento
   * @param {number} maintenanceId - ID del mantenimiento
   * @returns {Promise<Array>}
   */
  async getPhotos(maintenanceId) {
    try {
      const response = await api.get(
        `/maintenance-photos/${maintenanceId}`
      );
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching photos:', error);
      throw error;
    }
  },

  /**
   * Eliminar una foto
   * @param {number} photoId - ID de la foto
   * @returns {Promise<Object>}
   */
  async deletePhoto(photoId) {
    try {
      const response = await api.delete(
        `/maintenance-photos/${photoId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting photo:', error);
      throw error;
    }
  },

  /**
   * Generar Excel con fotos
   * @param {number} maintenanceId - ID del mantenimiento
   * @returns {Promise<void>}
   */
  async generateExcel(maintenanceId) {
    try {
      const response = await api.post(
        `/maintenance-photos/generate-excel/${maintenanceId}`,
        {},
        {
          responseType: 'blob',
          timeout: 300000 // 5 minutos para generar Excel con muchas fotos
        }
      );
      
      // Crear URL del blob para descargar
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `FotosMantenimiento_${maintenanceId}_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    } catch (error) {
      console.error('Error generating Excel:', error);
      throw error;
    }
  }
};
